// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".detMain[data-v-067e905d]{position:absolute;top:150px;bottom:40px;width:1200px}.courseCover[data-v-067e905d]{position:absolute;top:40px;left:0;right:0;bottom:20px}", ""]);
// Exports
module.exports = exports;
